var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 702.368,
    height: 405.829,
    viewBox: "0 0 702.368 405.829",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath18",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 304.372h526.776V0H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.33333 0 0 -1.33333 0 405.83)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath18)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(238.93 246.177)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#006096",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0a1.794 1.794 0 002.062 1.97A1.778 1.778 0 003.565.352a1.786 1.786 0 00-2.029-1.938A1.77 1.77 0 000 0m26.162 9.314a1.787 1.787 0 00-1.987-1.898 1.77 1.77 0 00-1.579 1.547 1.787 1.787 0 002.096 2.003 1.783 1.783 0 001.47-1.652M7.639-8.374l15.206 14.52c2.858-1.434 5.952 1.539 4.646 4.438a3.41 3.41 0 01-1.504 1.618c-2.908 1.567-6.121-1.509-4.696-4.485L4.36-8.45c-6.243.25-12.117 2.804-16.549 7.015L4.405 14.41a3.4 3.4 0 012.402-.3 3.422 3.422 0 012.282 4.774C25.021 34.1 22.527 31.718 24.577 33.674a25.242 25.242 0 004.043-6.343C23.094 22.056 9.097 8.688 3.365 3.214.759 4.583-2.234 2.224-1.538-.62a3.41 3.41 0 011.76-2.223c2.845-1.466 6.024 1.492 4.665 4.455 24.17 23.081 19.563 18.683 24.601 23.492C34.752 9.427 23.934-6.907 7.639-8.374m3.692 42.728a1.784 1.784 0 00-2.02-1.93 1.771 1.771 0 00-1.545 1.579c-.136 1.19.907 2.172 2.069 1.976a1.775 1.775 0 001.496-1.625M4.247 17.002c-.022.092-.03.183-.038.275a1.797 1.797 0 001.356 1.901c.226.054.452.06.667.031a1.796 1.796 0 001.509-1.352 1.52 1.52 0 00.034-.227 1.795 1.795 0 00-3.528-.628m-19.659 7c-.152 1.196.894 2.215 2.091 1.996a1.784 1.784 0 001.476-1.644 1.786 1.786 0 00-1.997-1.907c-.768.091-1.437.641-1.57 1.555m19.259 18.39l-15.871-15.156c-2.605 1.398-5.63-.959-4.929-3.82a3.422 3.422 0 014.131-2.505c2.037.499 3.187 2.735 2.304 4.711C6.207 41.596 2.762 38.305 7.039 42.388c6.055-.404 11.728-2.978 16.016-7.114L7.549 20.468a3.392 3.392 0 01-2.368.28 3.42 3.42 0 01-2.504-4.132c.052-.21.123-.411.21-.6C-14.626-.71-11.827 1.963-13.724.153a25.252 25.252 0 00-4.107 6.352L7.994 31.166c2.592-1.332 5.565 1.015 4.869 3.851a3.418 3.418 0 01-4.131 2.505 3.42 3.42 0 01-2.278-4.773L-18.709 8.721c-5.457 15.998 5.823 32.666 22.556 33.671m-5.054 1.413C-15.997 40.181-25.08 25.2-21.455 10.41-17.831-4.379-2.852-13.463 11.939-9.838c14.79 3.624 23.872 18.605 20.248 33.395C28.562 38.346 13.582 47.43-1.207 43.805"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(152.675 62.42)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0v34.791h-58.526L-78.794 0h-56.816L-3.272 229.217h52.747V84.034H0v51.483l-30.345-51.483h79.82V0z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M221.906 217.912h49.244V62.42h-49.244z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(458.4 17.544)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l.01 188.859-60.205-60.193-60.547 60.678V44.877l-49.256.123.013 229.511h48.582l60.839-76.239L.015 274.511h49.479l.14-38.369L49.621 0z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.058e9188cde3c10070654dbf725f8567.svg";
export { ForwardRef as ReactComponent };